import { render, staticRenderFns } from "./AdminPanelServices.vue?vue&type=template&id=a16bcf7e&scoped=true"
import script from "./AdminPanelServices.vue?vue&type=script&lang=js"
export * from "./AdminPanelServices.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelServices.vue?vue&type=style&index=0&id=a16bcf7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16bcf7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
